import gsap from "gsap";
import { ScrollTrigger } from "gsap/all.js";
import timelineModifierWithMultiplePauses from "../modules/TimelineModifierWithMultiplePauses.js";
gsap.registerPlugin(ScrollTrigger);

class PinnedHero extends HTMLElement {
  constructor() {
    super();
    this.init();
  }

  init() {
    const getIntMinMax = (num, min, max) => Math.min(Math.max(Math.floor(num), min), max);

    document.addEventListener("DOMContentLoaded", () => {
      const pinnedSection = this;
      const scrollHeight = this.dataset.size*500;
      const rowSize = parseInt(this.dataset.size);
      const pauseSize = 0.1;
      const pauses = [...new Array(rowSize - 2)].map((_, i) => ({
        position: ((1 / (rowSize - 1)) * (i + 1)), // - (pauseSize / 2),
        duration: pauseSize,
      }));

      this.scrollTrigger = ScrollTrigger.create({
        trigger: pinnedSection,
        start: "top top",
        end: `+=${scrollHeight}`,
        pin: true,
        pinSpacing: true,
        markers: false,
        scrub: true,
        onUpdate: (self) => {
          const slowedProgress = timelineModifierWithMultiplePauses(self.progress, pauses) * (rowSize-1) * 100;

          // For image transition
          this.style.setProperty('--scroll-percentage', `${slowedProgress}%`);

          const openAccordionIndex = getIntMinMax(self.progress * rowSize, 0, rowSize - 1);

          // Open the right accordion, close the others
          if (openAccordionIndex != this.openAccordionIndex) {
            this.openAccordionIndex = openAccordionIndex;

            this.querySelectorAll(`pinned-hero-row`).forEach((row, rowIndex) => {
              if (rowIndex == this.openAccordionIndex) {
                row._x_dataStack[0].rowOpen = true;
              }
              else {
                row._x_dataStack[0].rowOpen = false;
              }
            });
          }
        }
      })
    });
  }
}

customElements.define('pinned-hero', PinnedHero);
